import { atom } from 'recoil';

const pageInputChange = atom({
  key: 'pageInputChange',
  default: false,
});

export { pageInputChange };
